import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=5a6b2fed"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6b2fed')) {
      api.createRecord('5a6b2fed', component.options)
    } else {
      api.reload('5a6b2fed', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=5a6b2fed", function () {
      api.rerender('5a6b2fed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/Menu.vue"
export default component.exports